(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ReportExecute', ReportExecute);

    ReportExecute.$inject = ['$resource'];

    function ReportExecute ($resource) {
        var resourceUrl =  'api/report-executes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
